// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"94":"f0f22de7","220":"bec2b53d","546":"00e12a3c"}[chunkId] + ".css";
};